import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const S = '#00F5A0';

const FAQS = [
  {
    q: 'Où sont stockées mes données ?',
    a: 'Vos données sont hébergées sur des serveurs européens sécurisés (Supabase, Stockholm, Suède). Elles sont chiffrées côté client avant transmission : SafeHeir ne peut techniquement pas lire vos données en clair. Même en cas d\'accès aux infrastructures d\'hébergement, aucune information sensible ne pourrait être extraite. Votre compte est accessible depuis n\'importe quel appareil après authentification.',
  },
  {
    q: 'Qui peut voir mon coffre-fort ?',
    a: 'Personne, sauf vous. Même l\'équipe SafeHeir ne peut techniquement pas lire vos données : le chiffrement est effectué localement dans votre navigateur, avant tout stockage, avec une clé que vous seul possédez. Vos bénéficiaires ne reçoivent que ce que vous avez explicitement choisi de leur transmettre, au moment où vous l\'avez décidé — jamais avant le déclenchement.',
  },
  {
    q: 'Que se passe-t-il si je perds mon mot de passe ?',
    a: 'La récupération est impossible. Vos données étant chiffrées avec une clé dérivée de votre mot de passe, toute perte de celui-ci entraîne la perte définitive et irréversible de l\'accès à votre coffre-fort. SafeHeir ne conserve aucune copie de votre mot de passe et ne peut effectuer aucune récupération. Nous vous recommandons vivement de noter votre mot de passe dans un gestionnaire de mots de passe personnel ou sur un support papier conservé en lieu sûr.',
  },
  {
    q: 'Comment fonctionne le check-in ?',
    a: 'SafeHeir vous envoie un email de rappel selon la fréquence que vous avez configurée (hebdomadaire, mensuelle, trimestrielle…). Vous confirmez votre présence en vous connectant à l\'application ou en cliquant sur le lien de confirmation. Si vous ne répondez pas dans le délai de grâce configuré (24 h à 96 h après l\'échéance), vos bénéficiaires sont automatiquement alertés par email, dans l\'ordre de priorité que vous avez défini.',
  },
  {
    q: 'Comment supprimer mon compte ?',
    a: 'Rendez-vous dans Paramètres → Supprimer mon compte. Après confirmation, l\'ensemble de vos données sont effacées immédiatement et définitivement de votre navigateur : compte utilisateur, coffre-fort, bénéficiaires, historique de check-in. Cette action est irréversible et ne peut pas être annulée. Elle correspond à votre droit à l\'effacement prévu par l\'article 17 du RGPD.',
  },
  {
    q: 'SafeHeir est-il conforme RGPD ?',
    a: 'Oui. Vos données sont hébergées exclusivement sur des serveurs européens (Supabase, Stockholm, Suède) — aucun transfert hors Union Européenne pour le stockage. Le chiffrement client-side garantit que SafeHeir ne peut pas lire vos données en clair. Les emails transactionnels (check-in, alertes) sont envoyés via un prestataire tiers encadré par contrat de sous-traitance conforme à l\'article 28 du RGPD. Vous disposez de tous vos droits RGPD : accès, rectification, portabilité (export JSON depuis Paramètres), effacement, opposition.',
  },
  {
    q: 'Que reçoit mon bénéficiaire exactement ?',
    a: 'Votre bénéficiaire reçoit uniquement ce que vous avez choisi de partager avec lui, au moment où vous l\'avez configuré. En cas de déclenchement, il reçoit un email de notification expliquant la situation, les consignes personnalisées que vous lui avez rédigées, et un accès aux informations que vous avez décidé de lui transmettre. Il ne voit jamais les données du coffre-fort qui ne lui sont pas destinées, ni aucune information avant le déclenchement de l\'alerte.',
  },
  {
    q: 'SafeHeir peut-il accéder à mes mots de passe ?',
    a: 'Non — techniquement impossible. Le chiffrement de vos mots de passe et notes sensibles est effectué localement dans votre navigateur, avant tout stockage, avec une clé dérivée de votre identifiant de compte. SafeHeir ne reçoit jamais vos données en clair. Même en cas d\'accès physique aux infrastructures d\'hébergement (Vercel), aucune information sensible ne pourrait être extraite : les données chiffrées y sont inexistantes.',
  },
];

const FAQItem = ({ q, a, isOpen, onToggle }) => (
  <div style={{
    background: 'rgba(255,255,255,0.03)',
    border: `1px solid ${isOpen ? 'rgba(0,245,160,0.2)' : 'rgba(255,255,255,0.07)'}`,
    borderRadius: 12,
    overflow: 'hidden',
    transition: 'border-color 0.2s',
  }}>
    <button
      onClick={onToggle}
      style={{
        width: '100%', textAlign: 'left', background: 'none', border: 'none',
        padding: '18px 20px', cursor: 'pointer',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
      }}
    >
      <span style={{ fontSize: 15, fontWeight: 600, color: isOpen ? S : '#fff', lineHeight: 1.4 }}>
        {q}
      </span>
      <span style={{
        fontSize: 22, color: isOpen ? S : 'rgba(255,255,255,0.35)',
        flexShrink: 0, transition: 'transform 0.25s, color 0.2s',
        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
        display: 'inline-block', lineHeight: 1,
      }}>
        +
      </span>
    </button>
    {isOpen && (
      <div style={{
        padding: '0 20px 18px',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        paddingTop: 14,
        color: 'rgba(255,255,255,0.7)', fontSize: 14, lineHeight: 1.75,
      }}>
        {a}
      </div>
    )}
  </div>
);

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #050B1A 0%, #0A1628 50%, #0F1B3C 100%)',
      padding: '2rem 1rem 4rem',
    }}>
      <div style={{ maxWidth: '760px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '3rem' }}>
          <Link to="/" style={{
            color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem',
            display: 'inline-flex', alignItems: 'center', gap: '0.4rem', marginBottom: '2rem',
          }}
            onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
          >
            ← Retour à l'accueil
          </Link>
          <h1 style={{
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: '700',
            color: 'white', marginBottom: '0.5rem', letterSpacing: '-0.02em',
          }}>
            Questions fréquentes
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>
            SafeHeir — Tout ce que vous devez savoir
          </p>
        </div>

        {/* Accordion */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {FAQS.map((item, i) => (
            <FAQItem
              key={i}
              q={item.q}
              a={item.a}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(prev => prev === i ? null : i)}
            />
          ))}
        </div>

        {/* Contact CTA */}
        <div style={{
          marginTop: '3rem', padding: '1.5rem 2rem',
          background: 'rgba(0,245,160,0.04)', border: '1px solid rgba(0,245,160,0.1)',
          borderRadius: 14, textAlign: 'center',
        }}>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, margin: 0 }}>
            Vous n'avez pas trouvé la réponse à votre question ?{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: S, textDecoration: 'none', fontWeight: 600 }}>
              Contactez-nous
            </a>
          </p>
        </div>

        {/* Footer navigation */}
        <div style={{ marginTop: '2rem', textAlign: 'center', display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {[
            { to: '/legal/cgu', label: 'CGU' },
            { to: '/legal/confidentialite', label: 'Politique de confidentialité' },
            { to: '/legal/mentions-legales', label: 'Mentions légales' },
            { to: '/', label: 'Accueil' },
          ].map(({ to, label }) => (
            <Link key={to} to={to} style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
              onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
            >
              {label}
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
};

export default FAQPage;
